import { Funcionario, funcionario } from 'service/api'

import { CreateSlice } from './index'

export type EmployeeState = {
    employeeId: number
    employee: Funcionario | null
    setEmployeeId: (id: number) => void
}

export const createEmployeeSlice: CreateSlice<EmployeeState> = (set, get) => ({
    employeeId: -1,
    employee: null,
    setEmployeeId: (id: number) => {
        if (get().employeeId === id) return
        set({ employeeId: id, employee: null })

        funcionario.getById(id).then(
            fetched => {
                if (get().employeeId === id) {
                    set({ employee: fetched as Funcionario })
                }
            },
            () => {
                // On error (404 / network), keep employeeId set, employee null.
                // React Query retry handles recovery.
            },
        )
    },
})
